const { AutocompleteService, PlacesServiceStatus } = google.maps.places;

export default function(hint: string): Promise<SearchPlacesResult[]> {
  return new Promise((resolve, reject) => {
    const service = new AutocompleteService();

    const params = {
      input: hint,
      componentRestrictions: { country: 'ar' },
      types: ['(regions)']
    };

    if (params.input && params.input !== '') {
      service.getPlacePredictions(params, (results, status) => {
        if (
          status === PlacesServiceStatus.OK &&
          results &&
          results.length > 0
        ) {
          resolve(
            results.map(result => ({
              key: result.place_id,
              primary: result.structured_formatting.main_text,
              secondary: result.structured_formatting.secondary_text,
              placeId: result.place_id
            }))
          );
        } else {
          reject(status);
        }
      });
    } else {
      resolve([]);
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/searchPlaces.ts